import Alt from "alt";
export default new Alt();



// WEBPACK FOOTER //
// ./src/alt.js